import { GetTokenSilentlyVerboseResponse} from '@auth0/auth0-spa-js'
import create from 'zustand';
import { persist } from 'zustand/middleware';

type AuthStore = {
	jwt: GetTokenSilentlyVerboseResponse | null;
	setJWT: (jwt: GetTokenSilentlyVerboseResponse | null) => void;
};

const useAuthStore = create<AuthStore>(
	persist(
		(set) => ({
			jwt: <GetTokenSilentlyVerboseResponse | null>null,
			setJWT: (jwt) => {
				set({
					jwt,
				});
			},
		}),
		{
			name: 'ca-jwt-store',
			whitelist: ['jwt'],
		}
	)
);

export default useAuthStore;
